<script>
import TablePage from '../../../../../../../components/table_page';
import configs from './config';

export default {
  extends: TablePage,
  props: {
    data: Array,
    value: [],
    selectKeys: Array,
    cusCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      configs,
      selection: [],
      params: {
        custCode: this.cusCode,
      },
    };
  },

  created() {
    this.getConfigList('product_table');
  },
  methods: {
    afterCheckboxChange() {
      this.$emit('onSelect', this.selectRow);
    },
    afterCheckAllChange(val) {
      this.$emit('onSelect', val.selection);
    },
    afterGetList() {
      this.selection = this.selectKeys || [];
    },
  },

};
</script>

<style>

</style>
